import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, Inject, LOCALE_ID } from '@angular/core';
import { PurchaseService } from '@schoolbelle/api/purchase';
import { FormGroup, FormControl } from '@angular/forms';
import { AuthService } from '@schoolbelle/api/auth';
import { sum, get } from 'lodash-es';
import { PurchaseModel } from '../purchase-model';

@Component({
  selector: 'app-quote',
  templateUrl: './quote.component.html',
  styleUrls: ['./quote.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class QuoteComponent implements OnInit {
  @Input() form:FormGroup; 
  paymentCurrency:FormControl;
  taxRate:FormControl;
  constructor(
    private auth:AuthService,
    private purchase:PurchaseService,
    @Inject(LOCALE_ID) public localeId:string,
    private cdRef:ChangeDetectorRef,
  ) { }
  get data () {
    const model:PurchaseModel = this.form.value;
    return {
      now:Date.now(),
      user_name:this.auth.currentUser.name,
      user_phone_number:this.auth.currentUser.phone_number,

      buyer_name:model.buyerInfo.groupName,
      group_name:model.buyerInfo.groupName,
      payment_type:model.paymentType,
      payment_currency:model.paymentCurrency,
      tax_rate:model.taxRate,
      items: model.products.map((product)=>{
        const productData = this.purchase.currentProducts.find(p=>p.product_id === product.productId);
        return {
          product_id:product.productId,
          amount:product.amount,
          quantity:product.quantity,
          starts_at: productData && productData.expires ? product.startsAt : null,
          expires_at: productData && productData.expires ? product.expiresAt : null,
          product:productData,
        };
      }),
      type:'school',
      extra_data:{
        group_name: model.buyerInfo.groupName,
        group_type: model.buyerInfo.groupType,
        // group_size: model.buyerInfo.groupSize,
        group_address: model.buyerInfo.groupAddress,
        // group_head_name: model.buyerInfo.groupHeadName,
        person_in_charge_email: model.personInCharge.personInChargeEmail,
        accountant_email: model.accountant && model.accountant.accountantEmail,
      },
      starts_at:model.products[0] && model.products[0].startsAt,
      expires_at:model.products[0] && model.products[0].expiresAt,
      comment:model.message,
      payment_amount: sum(model.products.map(product=>{
        const {amount, quantity} = product;
        const productData = this.purchase.currentProducts.find(p=>p.product_id === product.productId);
        if (!productData) return 0;
        const {price_amount} = productData;
        const price_amount_with_currency = (get(price_amount, [model.paymentCurrency]) || 0);
        return price_amount_with_currency * amount * quantity * (1 + this.taxRate.value);
      })) 
    }     
  }

  ngOnInit() {
    this.paymentCurrency = this.form.get('paymentCurrency') as FormControl;
    this.taxRate = this.form.get('taxRate') as FormControl;
    this.form.valueChanges.subscribe(()=>{
      this.cdRef.detectChanges();
    });
  }
}